var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookkeeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.567,
    height: 78.847,
    viewBox: "0 0 80.567 78.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookkeeping_8870356",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M78.928,34.087H68.074V4.644A3.3,3.3,0,0,0,64.831,1.4H11.808A3.391,3.391,0,0,0,8.565,4.644v11.6c-4.491-2.62-4.491,5.614,0,4.045V27.6c-4.99,0-4.99,4.21,0,4.21v6.582c-4.491.25-4.491,6.549,0,6.549V50c-4.491-1.818-4.491,6.416,0,6.416v5.739c-4.491-2.5-4.491,5.739,0,4.483V77a3.3,3.3,0,0,0,3.244,3.244h67a3.089,3.089,0,0,0,3.119-3.119V37.206a2.914,2.914,0,0,0-2.994-3.119ZM11.06,77V66.64c8.359,0,8.359-6.853,0-4.483V56.543c8.359,0,8.359-6.541,0-6.541V45.065c8.359,0,8.359-5.394,0-5.394V31.81c8.359,0,8.359-4.845,0-4.845V20.291c8.359,2.068,8.359-6.166,0-4.525V4.644a.8.8,0,0,1,.749-.749h52.9a.8.8,0,0,1,.749.749V33.962H47.614A3.089,3.089,0,0,0,44.5,37.081V77a.935.935,0,0,0,.125.624H11.808A.7.7,0,0,1,11.06,77Zm68.492,0a.589.589,0,0,1-.624.624H47.739A.589.589,0,0,1,47.115,77v-39.8a.589.589,0,0,1,.624-.624h31.19a.589.589,0,0,1,.624.624Z",
    transform: "translate(-4.363 -1.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M63.754,32.3H41.048A1.179,1.179,0,0,0,39.8,33.548v8.858a1.179,1.179,0,0,0,1.248,1.248H63.754A1.179,1.179,0,0,0,65,42.405V33.548A1.179,1.179,0,0,0,63.754,32.3Zm-1.248,8.858H42.3V34.8H62.506Z",
    transform: "translate(6.445 6.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M59.162,46.4H53.548a1.248,1.248,0,1,0,0,2.5h5.614a1.179,1.179,0,0,0,1.248-1.248A1.25,1.25,0,0,0,59.162,46.4Z",
    transform: "translate(9.54 9.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M59.162,53.8H53.548a1.248,1.248,0,1,0,0,2.5h5.614a1.248,1.248,0,0,0,0-2.5Z",
    transform: "translate(9.54 11.573)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M59.162,57.8H53.548a1.248,1.248,0,1,0,0,2.5h5.614a1.179,1.179,0,0,0,1.248-1.248A1.25,1.25,0,0,0,59.162,57.8Z",
    transform: "translate(9.54 12.564)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M47.862,46.945h-1.5v-1.5a1.248,1.248,0,1,0-2.5,0v1.5H42.248a1.248,1.248,0,0,0,0,2.5h1.5v1.5a1.248,1.248,0,1,0,2.5,0v-1.5h1.5a1.179,1.179,0,0,0,1.248-1.248A1.079,1.079,0,0,0,47.862,46.945Z",
    transform: "translate(6.742 9.197)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M47.813,54.874a1.206,1.206,0,0,0-1.747,0L44.944,56l-1.123-1.123a1.235,1.235,0,0,0-1.747,1.747L43.2,57.744l-1.123,1.123a1.206,1.206,0,0,0,0,1.747,1.348,1.348,0,0,0,.873.374,1.133,1.133,0,0,0,.873-.374l1.123-1.123,1.123,1.123a1.348,1.348,0,0,0,.873.374,1.133,1.133,0,0,0,.873-.374,1.206,1.206,0,0,0,0-1.747L46.69,57.744l1.123-1.123A1.206,1.206,0,0,0,47.813,54.874Z",
    transform: "translate(6.915 11.747)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_5",
    "data-name": "Ret\\xE2ngulo 5",
    transform: "translate(0 60.321)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.396,
    height: 4.113,
    rx: 2.057,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 17.396,
    height: 7.113,
    rx: 3.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_6",
    "data-name": "Ret\\xE2ngulo 6",
    transform: "translate(0 37.699)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.396,
    height: 4.113,
    rx: 2.057,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 17.396,
    height: 7.113,
    rx: 3.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_7",
    "data-name": "Ret\\xE2ngulo 7",
    transform: "translate(0 14.392)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.396,
    height: 4.113,
    rx: 2.057,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 17.396,
    height: 7.113,
    rx: 3.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_8",
    "data-name": "Ret\\xE2ngulo 8",
    transform: "translate(0 26.045)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.396,
    height: 4.113,
    rx: 2.057,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 17.396,
    height: 7.113,
    rx: 3.557,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_9",
    "data-name": "Ret\\xE2ngulo 9",
    transform: "translate(0 49.352)",
    fill: "#e5f3f8",
    stroke: "#008abb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.396,
    height: 4.113,
    rx: 2.057,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: -1.5,
    width: 17.396,
    height: 7.113,
    rx: 3.557,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookkeeping);
export default __webpack_public_path__ + "static/media/icon_bookkeeping.d77d17c05b6f13992f75746d5db0a543.svg";
export { ForwardRef as ReactComponent };